interface Props {
  photos: string[];
  alt?: string;
}

export function PhotoGrid({ photos, alt = '' }: Props) {
  if (photos.length === 0) return null;
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {photos.map((src) => (
        <img
          key={src}
          src={src}
          alt={alt}
          loading="lazy"
          className="h-32 w-full rounded-lg object-cover"
        />
      ))}
    </div>
  );
}
